import { render, staticRenderFns } from "./SubTransactionTable.vue?vue&type=template&id=fdcdb294&"
import script from "./SubTransactionTable.vue?vue&type=script&lang=js&"
export * from "./SubTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports